require('../modules/es.escape');
var global = require('../internals/global');

module.exports = global.escape;
